export interface ISidebarState {
  mobileSidebarVisible: boolean;
}

export const sidebarState = {
  mobileSidebarVisible: false,
} as ISidebarState;
